export class OpenLRCoordinate {
  latitude: number;
  longitude: number;
}



// WEBPACK FOOTER //
// ./src/app/models/openlr/openlrcoordinate.model.ts